import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";
export default id => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/CLONE", payload: { id } });
  debouncedSaveTemplate(dispatch, getState);
};
